const randomIndex = (count: number): number => {
  const buffer = new Uint32Array(1)
  globalThis.crypto.getRandomValues(buffer)
  return buffer[0]! % count
}

/**
 * Picks a random time-of-day greeting key from the `ask` namespace
 * (`greetings.morning_2`, `greetings.night_1`, …). Call once and cache so
 * re-renders don't re-roll the greeting.
 */
export const pickGreetingKey = (now: Date = new Date()): string => {
  const hour = now.getHours()
  let period: string
  let count: number

  if (hour >= 5 && hour < 12) {
    period = "morning"
    count = 4
  } else if (hour >= 12 && hour < 17) {
    period = "afternoon"
    count = 3
  } else if (hour >= 17 && hour < 21) {
    period = "evening"
    count = 3
  } else {
    period = "night"
    count = 3
  }

  return `greetings.${period}_${randomIndex(count) + 1}`
}
